import { setupResponseInterceptor } from '@api/inteceptors/capitalize.interceptor';
import { Api as UsersApi } from '@api/READ_ONLY//users_api/Api';
import { Api as BillingApi } from '@api/READ_ONLY/billing_api/Api';
import { Api as CaregiverApi } from '@api/READ_ONLY/caregiver_api/Api';
import { Api as ClientApi } from '@api/READ_ONLY/client_api/Api';
import { Api as DoctorsApi } from '@api/READ_ONLY/doctors_api/Api';
import { Api as NotificationsApi } from '@api/READ_ONLY/notifications_api/Api';
import { Api as ServiceRequestApi } from '@api/READ_ONLY/service_request_api/Api';
import { Api as ServicesApi } from '@api/READ_ONLY/services_api/Api';
import { Api as VisitsApi } from '@api/READ_ONLY/visits_api/Api';
import envConfig from '@app/enviroment/enviroment';
import { captureError } from '@app/lib/Sentry';
import { securityWorker } from './securityWorker';
const BASE_URL = envConfig.getEnvKey('API_URL') as string;

const _ApiClient = {
  clientApi: new ClientApi({
    baseURL: `${BASE_URL}/api/v1/clients-api`,
    securityWorker,
    secure: true,
  }),
  caregiverApi: new CaregiverApi({
    baseURL: `${BASE_URL}/api/v1/caregivers-api`,
    securityWorker,
    secure: true,
  }),
  serviceApi: new ServicesApi({
    baseURL: `${BASE_URL}/api/v1/services-api`,
    securityWorker,
    secure: true,
  }),
  visitsApi: new VisitsApi({
    baseURL: `${BASE_URL}/api/v1/visits-api`,
    securityWorker,
    secure: true,
  }),
  serviceRequestsApi: new ServiceRequestApi({
    baseURL: `${BASE_URL}/api/v1/requests-api`,
    securityWorker,
    secure: true,
  }),
  usersApi: new UsersApi({
    baseURL: `${BASE_URL}/api/v1/users-api`,
    securityWorker,
    secure: true,
  }),
  notificationsApi: new NotificationsApi({
    baseURL: `${BASE_URL}/api/v1/notifications-api`,
    securityWorker,
    secure: true,
  }),
  doctorsApi: new DoctorsApi({
    baseURL: `${BASE_URL}/api/v1/doctors-api`,
    securityWorker,
    secure: true,
  }),
  billingApi: new BillingApi({
    baseURL: `${BASE_URL}/api/v1/billing-api`,
    securityWorker,
    secure: true,
  }),
};

// Normalize query array serialization to repeated keys (arr=1&arr=2),
// instead of the default bracket format (arr[]=1&arr[]=2), for better backend compatibility.
Object.values(_ApiClient).forEach((api) => {
  try {
    // Provide a custom serializer so arrays become repeated keys without brackets
    // Example: { services: [4,5] } => services=4&services=5
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    api.instance.defaults.paramsSerializer = {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      serialize: (params: Record<string, any>) => {
        const usp = new URLSearchParams();
        Object.entries(params || {}).forEach(([key, value]) => {
          if (Array.isArray(value)) {
            value.forEach((v) => {
              if (v !== undefined && v !== null) usp.append(key, String(v));
            });
          } else if (value !== undefined && value !== null) {
            usp.append(key, String(value));
          }
        });
        return usp.toString();
      },
    };
  } catch (e) {
    captureError(e as Error, { context: 'API params serializer setup' });
  }
});

// Setup response interceptors for all API instances
Object.values(_ApiClient).forEach((api, index) => {
  const clientKey = Object.keys(_ApiClient)[index];
  setupResponseInterceptor(clientKey, api.instance);
});

export const ApiClient = _ApiClient;
